import React from "react";
import styles from "./index.module.scss";
import FacebookIcon from "./assets/fb.svg";
import LinkedInIcon from "./assets/in.svg";
import TwitterIcon from "./assets/tw.svg";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

export default function SocialNetworks() {
  const url = typeof window !== "undefined" && `${window.location.href}`;
  return (
    <div className={styles.container}>
      <TwitterShareButton url={url}>
        <TwitterIcon />
      </TwitterShareButton>
      <FacebookShareButton url={url}>
        <FacebookIcon />
      </FacebookShareButton>
      <LinkedinShareButton url={url}>
        <LinkedInIcon />
      </LinkedinShareButton>
    </div>
  );
}
